import { Navigate } from "react-router-dom"

const UserSettings = () => {
  return <Navigate to="/settings/profile" replace />
}

export default UserSettings
